import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AppThemeProvider } from './theme/AppThemeProvider';
import { CookieConsentProvider } from './consent/CookieConsentProvider';
import CookieBanner from './components/CookieBanner';
import AppErrorBoundary from './components/AppErrorBoundary';
import OfflineConnectionOverlay from './components/OfflineConnectionOverlay';
import BackOnlineToast from './components/BackOnlineToast';
import SoftSuccessToast from './components/SoftSuccessToast';
import ScrollProgressBar from './components/ScrollProgressBar';
import { PwaProvider } from './pwa/PwaProvider';

// Применение глобального провайдера темы и CSS‑переменных


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppThemeProvider>
        <AppErrorBoundary>
          <PwaProvider>
            <CookieConsentProvider>
              <App />
              <CookieBanner />
              <OfflineConnectionOverlay />
              <BackOnlineToast />
              <SoftSuccessToast />
              <ScrollProgressBar />
            </CookieConsentProvider>
          </PwaProvider>
        </AppErrorBoundary>
      </AppThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
